import React, { useState } from 'react';
import { ControlledConfirmDialog } from 'src/shared/components/confirm/ControlledConfirmDialog';
import { useDeleteProjectDefinitionMutation } from 'src/app/projects/views/project-list/state/api/projectListGraphSlice';

type DeleteDefinitionDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    projectId: string;
    projectName: string;
};

const DeleteDefinitionDialog = ({ open, onOpenChange, projectId, projectName }: DeleteDefinitionDialogProps) => {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [deleteProjectDefinition, { isLoading }] = useDeleteProjectDefinitionMutation();

    const handleOpenChange = (nextOpen: boolean) => {
        if (!nextOpen) {
            setErrorMessage(null);
        }
        onOpenChange(nextOpen);
    };

    const handleDelete = async () => {
        setErrorMessage(null);
        try {
            await deleteProjectDefinition({ projectId }).unwrap();
            onOpenChange(false);
        } catch {
            setErrorMessage('Something went wrong deleting the definition. Please try again.');
        }
    };

    return (
        <ControlledConfirmDialog
            open={open}
            onOpenChange={handleOpenChange}
            variant='confirm'
            title={`Delete Project Definition for ${projectName}?`}
            description={
                <>
                    The project definition will be removed, and this cannot be undone. The project itself is not deleted, so a new
                    definition can be added afterwards.
                    {errorMessage && (
                        <span role='alert' className='block mt-2 text-red-100'>
                            {errorMessage}
                        </span>
                    )}
                </>
            }
            confirmLabel='Delete definition'
            onConfirm={handleDelete}
            isConfirming={isLoading}
        />
    );
};

export default DeleteDefinitionDialog;
